module.exports = __webpack_public_path__ + "img/Sugar1.c6ddcd9b.jpg";